module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/image--connect-2-ab599d12.png";